import React from 'react';
import useSWR from 'swr';

import { NomenclatureGroupsCard } from 'components/Cards';
import { useStores } from 'hooks/useStores';

import styles from './RelatedCategories.module.scss';

const RelatedCategories = ({ slug, title = 'Связанные категории' }) => {
  const { api } = useStores();
  const { data } = useSWR(
    { slug, _key: `ng-related-categories-${slug}` },
    api.newCatalog.getRelatedCategoriesBySlug
  );

  if (!data?.length) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.grid}>
          {data.map((group) => (
            <NomenclatureGroupsCard key={group.id} group={group} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedCategories;
